import Switcher from "@components/switcher/Switcher";
import React from "react";
import PrimeCanadaOrderFlowDetails from "./PrimeCanadaOrderFlowDetails";
import PrimeCanadaUserDetails from "./PrimeCanadaUserDetails";
import PrimeLogs from "./PrimeLogs";

interface PrimeDetailsCanadaTabsProps {
  instanceId: string;
  width?: string;
  onEventChange?: (instanceId: string, newEventId: number) => void;
}

const PrimeDetailsCanadaTabs: React.FC<PrimeDetailsCanadaTabsProps> = ({
  instanceId,
  onEventChange,
}) => {
  const tabs = [
    {
      label: "TRADE",
      component: (
        <PrimeCanadaOrderFlowDetails
          instanceId={instanceId}
          onEventChange={onEventChange}
        />
      ),
    },
    {
      label: "USER",
      component: <PrimeCanadaUserDetails instanceId={instanceId} />,
    },
    {
      label: "LOGS",
      component: (
        <PrimeLogs
          instanceId={instanceId}
          endPoint="/adminPanel/getCADCallbackLogs"
          sendCallbackEndPoint="/adminPanel/sendCADCallbackForLog"
        />
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default PrimeDetailsCanadaTabs;
